package com.schoolconnect.app

import kotlinx.browser.document
import kotlinx.browser.window
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual fun downloadFile(fileName: String, bytes: ByteArray, mimeType: String): Boolean {
    val buffer = Uint8Array(bytes.size)
    buffer.set(bytes.toTypedArray())
    val blob = Blob(arrayOf(buffer.buffer), BlobPropertyBag(type = mimeType))
    val url = URL.createObjectURL(blob)
    val anchor = document.createElement("a") as HTMLAnchorElement
    anchor.href = url
    anchor.download = fileName
    anchor.style.display = "none"
    document.body?.appendChild(anchor)
    anchor.click()
    window.setTimeout({
        anchor.remove()
        URL.revokeObjectURL(url)
    }, 1_000)
    return true
}
